import "./sw-header.module.css";
import { html, LANGUAGE } from "../global";
import Strings from "../../models/Strings.json";

const TROPHY = new URL("../../public/trophy.svg", import.meta.url).href;

const template = document.createElement("template");
template.innerHTML = html`
    <nav
        class="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
        <div
            class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
            <aside class="flex items-center space-x-3 rtl:space-x-reverse">
                <button
                    data-drawer-target="sw-menu"
                    data-drawer-show="sw-menu"
                    onclick="heartbank.alertAdmin('header/click/menu')"
                    type="button"
                    class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    aria-controls="navbar-default"
                    aria-expanded="false">
                    <span class="sr-only">${Strings.open[LANGUAGE]}</span>
                    <svg
                        class="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 17 14">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 1h15M1 7h15M1 13h15" />
                    </svg>
                </button>
                <div id="title-home" class="hidden">
                    <button
                        data-modal-show="sw-feedback"
                        onclick="heartbank.alertAdmin('header/home/click/${Strings
                            .title2[LANGUAGE]}')"
                        class="moul self-center ${LANGUAGE === "khmer"
                            ? "text-xl"
                            : "text-3xl"} font-semibold whitespace-nowrap text-theme">
                        ${Strings.title[LANGUAGE]}
                    </button>
                </div>
                <div id="title-page" class="hidden">
                    <button
                        onclick="heartbank.alertAdmin('header/page/click/${Strings
                            .book[LANGUAGE]}')"
                        class="moul self-center text-xl md:text-2xl font-semibold whitespace-nowrap">
                        ${Strings.book[LANGUAGE]}
                    </button>
                    <span
                        class="moul ms-2 bg-blue-100 text-blue-800 text-lg md:text-2xl font-black me-2 px-2 md:px-4 py-0 rounded dark:bg-blue-900 dark:text-blue-300"></span>
                </div>
                <div id="title-map" class="hidden">
                    <button
                        data-modal-show="sw-feedback"
                        onclick="heartbank.alertAdmin('header/map/click/title')"
                        class="moul self-center text-2xl font-semibold whitespace-nowrap text-theme"></button>
                </div>
            </aside>
            <div
                class="hidden"
                id="sw-header-home"
                class="flex items-center md:order-2 space-x-1 md:space-x-0 rtl:space-x-reverse">
                <button
                    type="button"
                    onclick="heartbank.alertAdmin('header/home/click/${Strings[
                        LANGUAGE
                    ][LANGUAGE]}')"
                    data-dropdown-toggle="language-dropdown-menu"
                    class="inline-flex items-center font-medium justify-center px-4 py-2 text-sm text-gray-500 dark:text-gray-300 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
                    <svg
                        class="w-5 h-5 rounded-full me-3"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        fill="currentColor"
                        width="20"
                        viewBox="0 0 512 512">
                        <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                        <path
                            d="${LANGUAGE === "khmer"
                                ? "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9l2.3 0c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
                                : "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}" />
                    </svg>
                    ${Strings[LANGUAGE][LANGUAGE]}
                </button>
                <!-- Dropdown -->
                <div
                    class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700"
                    id="language-dropdown-menu">
                    <ul class="py-2 font-medium" role="none">
                        <li
                            id="khmer"
                            onclick="heartbank.alertAdmin('header/home/click/${Strings
                                .khmer[LANGUAGE]}')"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                            role="menuitem">
                            <button class="inline-flex items-center">
                                <span class="text-base me-3">🇰🇭</span>
                                ${Strings.khmer[LANGUAGE]}
                            </button>
                        </li>
                        <li
                            id="english"
                            onclick="heartbank.alertAdmin('header/home/click/${Strings
                                .english[LANGUAGE]}')"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                            role="menuitem">
                            <button class="inline-flex items-center">
                                <span class="text-base me-3">🇺🇸</span>
                                <!--<svg
                                    class="h-3.5 w-3.5 me-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 36.1-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3l0 33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-70.5 0-32.7 0-63.3 0-32.7 0-63.3 0-32.7L0 64 0 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z" />
                                </svg>-->
                                ${Strings.english[LANGUAGE]}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="sw-header-page" class="hidden cursor-pointer">
                <button id="book-marked" class="hidden">
                    <svg
                        class="w-7 h-10"
                        onclick="heartbank.alertAdmin('header/page/remove/bookmark')"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512">
                        <path
                            fill="red"
                            d="M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z" />
                    </svg>
                </button>
                <button id="book-mark" class="hidden">
                    <svg
                        class="w-7 h-10"
                        onclick="heartbank.alertAdmin('header/page/add/bookmark')"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512">
                        <path
                            fill="blueviolet"
                            d="M0 96C0 43 43 0 96 0l96 0 0 190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5L352 0l32 0 32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32z" />
                    </svg>
                </button>
            </div>
            <div
                id="sw-header-map"
                class="hidden rounded-md shadow-xs"
                role="group">
                <img
                    id="sw-header-map-prize"
                    onclick="heartbank.alertAdmin('header/map/click/prize');prompt('${Strings
                        .map34[LANGUAGE]}','${Strings.soon[LANGUAGE]}')"
                    src="${TROPHY}"
                    width="35"
                    height="35"
                    class="me-3 cursor-pointer" />
                <div
                    id="sw-header-map-calendar"
                    onclick="heartbank.alertAdmin('header/map/click/calendar')"
                    inline-datepicker
                    data-date="09/28/2026"
                    class="hidden absolute top-32 left-1/2 transform -translate-x-1/2"></div>
                <button
                    id="sw-header-map-me"
                    onclick="heartbank.alertAdmin('header/map/click/me')"
                    type="button"
                    class="text-white bg-hb hover:bg-hb/50 focus:ring-4 focus:outline-none focus:ring-hb/25 font-medium rounded-lg text-sm px-3 py-2 text-center">
                    ${Strings.map16[LANGUAGE]}
                </button>
                <button
                    id="sw-header-map-heartbank"
                    onclick="heartbank.alertAdmin('header/map/click/heartbank')"
                    type="button"
                    class="hidden text-white bg-hb hover:bg-hb/50 focus:ring-4 focus:outline-none focus:ring-hb/25 font-medium rounded-lg text-sm px-3 py-2 text-center">
                    ${Strings.map5[LANGUAGE]}
                </button>
                <button
                    id="sw-header-map-feedback"
                    onclick="heartbank.alertAdmin('header/map/click/feedback')"
                    type="button"
                    class="hidden pl-4 pr-2 py-2 text-white bg-hb hover:bg-hb/50 focus:ring-4 focus:outline-none focus:ring-hb/25 font-medium rounded-lg text-sm text-center">
                    <aside id="sw-donate-hb">
                        Heart
                        <svg
                            class="mt-[-1px] ml-[-6px] mr-[-4px] inline fill-white"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="19"
                            height="19">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank<sup>®</sup>
                    </aside>
                </button>
            </div>
        </div>
    </nav>
`;

export default template;
